import { toRGBA } from '../utils';

const gumby = [78, 199, 121];
const g = (opacity: number = 1) =>
  toRGBA(gumby[0], gumby[1], gumby[2], opacity);

export default g;
